import angular from 'angular';

class modalExportInvitationCtrl {
  /*@ngInject*/
  constructor(PrincipalSvc, CONF) {
    this.PrincipalSvc = PrincipalSvc;
    this.CONF = CONF;
  }

  $onInit() {
    this.principal = angular.copy(this.resolve.principal);
    this.reportData = angular.copy(this.resolve.reportData);
    this.hasWarnings = this.reportData.nbPaperSent < this.reportData.nbMaxPaperSent;
  }

  cancel() {
    this.modalInstance.dismiss();
  }
}

angular.module('app.principal').component('modalExportInvitation', {
  templateUrl: require('./modal-export-invitation.html'),
  controller: modalExportInvitationCtrl,
  bindings: {
    modalInstance: '<',
    resolve: '<'
  }
});
